// app/routes/_auth.reach.login.tsx
import {
  ActionFunctionArgs,
  LoaderFunctionArgs,
  redirect,
} from "@remix-run/node";
import { useLoaderData } from "@remix-run/react";
import { authenticator } from "~/services/reach-auth.server";
import { Card, CardBody } from "@heroui/card";
import { Button } from "@heroui/button";
import { Input } from "@heroui/input";
import * as React from "react";
import ErrorToast from "~/components/ui/error-toast";
import ReachLogo from "~/assets/images/reach-logo.png";
import { Image } from "@heroui/image";
import { commitSession, getSession } from "~/services/reach.session.server";

export default function Login() {
  const { isRetry } = useLoaderData<typeof loader>();
  const [showLoginError, setShowLoginError] = React.useState(isRetry);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <Card className="w-full max-w-md p-12 pt-6">
        <CardBody className="flex flex-col items-center">
          <Image
            src={ReachLogo}
            alt="Reach Logo"
            width={100}
            className="mx-auto mb-6"
          />
          <form method="post" className="space-y-6 w-full">
            <Input
              id="email"
              name="email"
              type="email"
              label="E-Mail"
              isRequired
              isInvalid={showLoginError}
              errorMessage="Invalid email or password"
            />
            <Input
              id="password"
              name="password"
              type="password"
              label="Passwort"
              placeholder="••••••••"
              isRequired
              isInvalid={showLoginError}
            />
            <Button type="submit" color="primary" fullWidth>
              Log in
            </Button>
          </form>
        </CardBody>
      </Card>
      <ErrorToast
        open={showLoginError}
        title={"Invalid Email or Password"}
        description={""}
        closeCallback={() => setShowLoginError(false)}
      />
    </div>
  );
}

export async function action({ request }: ActionFunctionArgs) {
  try {
    const user = await authenticator.authenticate("user-password", request);
    const session = await getSession(request.headers.get("Cookie"));
    session.set("user", user);

    return redirect("/reach", {
      headers: {
        "Set-Cookie": await commitSession(session),
      },
    });
  } catch (error) {
    console.error(error);
    return redirect("/reach/login?retry");
  }
}

export async function loader({ request }: LoaderFunctionArgs) {
  const { searchParams } = new URL(request.url);

  await authenticator.isAuthenticated(request, {
    successRedirect: "/reach",
  });

  return {
    isRetry: searchParams.has("retry"),
  };
}
